import * as React from "react";
import { DefinitionList } from "components/common";
import useAttributeComponents from "components/event-definitions/replay-search/hooks/useAttributeComponents";
import NoAttributeProvided from "components/event-definitions/replay-search/NoAttributeProvided";
const EventDefinitionInfoList = () => {
  const infoAttributes = useAttributeComponents();
  return /* @__PURE__ */ React.createElement(DefinitionList, null, infoAttributes.map(
    ({ title, content, show }) => show !== false && /* @__PURE__ */ React.createElement(React.Fragment, { key: title }, /* @__PURE__ */ React.createElement("dt", null, title), /* @__PURE__ */ React.createElement("dd", { title }, content || /* @__PURE__ */ React.createElement(NoAttributeProvided, null)))
  ));
};
export default EventDefinitionInfoList;
